// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__xbNUK","footer":"ModalUpdate_footer__1QAjT"};